<div class="app-checkbox" (click)="onClick()" tabindex="0" (keyup)="$event.keyCode === 32 && onClick()">
  <input type="hidden" [checked]="isChecked" />
  <div class="checker text-primary">
    <i *ngIf="isChecked" class="fas fa-check"></i>
  </div>
  <ng-content></ng-content>
</div>
